import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IntegrationQuickbooksService {

  private baseurl = "";
  private dasbaseurl = "";

  private apiroute = "";
  quickbooksurl= "";

  constructor(
    private http: HttpClient,
    private appSetting: AppConfigService,
  ) {
    this.baseurl = this.appSetting.apiBaseUrl;
    this.dasbaseurl = this.appSetting.newdashboardURL;

    this.apiroute = '/FlexIntegration';

    if(!appSetting.appConfig) {
      appSetting.loadAppConfig()
    }

    this.quickbooksurl = this.appSetting.appConfig.quickbooksurl;   

  }

  //Customers
  // SP_API_Flex_Get_AcctQBCUSTOMER_CUBE
  GetClients() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: "Get_Clients" });
  }

  Get_AllBiDashboardComponents() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: "Get_AllBiDashboardComponents" });
  }

  Get_AllBiDashboardComponentsWithModules() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: "Get_AllBiDashboardComponentsWithModules" });
  }

  Get_AllBiDashboardComponentsClients() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: "Get_AllBiDashboardComponentsClients" });
  }

  Get_MasterDashboardComponents() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: "Get_MasterDashboardComponents" });
  }

  Get_MasterDashboards() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: "Get_AllTemplateDashboards" });
  }

  Get_MasterDashboardsServices() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: "Get_MasterDashboardsServices" });
  }

  InsertUpdate_ComponentsServices(obj: any) {
    return this.http.post<any>(this.baseurl + this.apiroute, obj);
  }

  Insert_Bi_Module(name: string, moduleid: string, id: string) {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: "Insert_Bi_Module", name: name, id: id, moduleid: moduleid });
  }

  GetDataSourceModules() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: "GetDataSourceModules" });
  }


  DeleteDataSourceModules(id: string) {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: "DeleteDataSourceModules", id: id });
  }

  InsertDataSourceModules(obj: any) {
    return this.http.post<any>(this.baseurl + this.apiroute, obj);
  }

  InsertDataBISource(obj: any) {
    return this.http.post<any>(this.baseurl + this.apiroute, obj);
  }

  Bi_GetDashboardsAvailableSP() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: "Bi_GetDashboardsAvailableSP" });
  }

  Get_CubeNavBIAll() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: "Get_CubeNavBIAll" });
  }

  CubeComponentServiceBestForList() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: "CubeComponentServiceBestForList" });
  }

  Get_CubeEdgeStoredProcedures() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: "Get_CubeEdgeStoredProceduresComponents", procedurename: '' });
  }

  Bi_GetDashboardsDataSources() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: "Bi_GetDashboardsDataSources" });
  }

  GetDashboardsAvailableSP() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: "GetDashboardsAvailableSP" });
  }

  updateBIComponents2(dashboardComponentConfiguration: any): Observable<any> {
    var mytoken = localStorage.getItem('token');
    dashboardComponentConfiguration.mtoken = mytoken;
    const url = this.dasbaseurl + 'updateBIComponents';
    return this.http.post(url, dashboardComponentConfiguration);
  }  

  deleteDashboard(dashboardComponentConfiguration: any): Observable<any> {
    var mytoken = localStorage.getItem('token');
    dashboardComponentConfiguration.mtoken = mytoken;
    const url = this.dasbaseurl + 'deleteBIComponents';
    return this.http.post(url, dashboardComponentConfiguration);
  }  

  updateBIComponents(data: any) {
    return this.http.post<any>('https://localhost:44376/Home/updateBIComponents', data);
  }

  GetCubeCustomers(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: "Get_AcctQBCUSTOMER_CUBE", pageindex: page, pagesize: size, searchtext: filter });
  }

  GetCustomersQb(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBCUSTOMER_QB", "pageindex": page, "pagesize": size, "searchtext": filter });
  }

  GetCustomersSynchronizedQb(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBCUSTOMER_SYNCH", "pageindex": page, "pagesize": size, "searchtext": filter })
  }

  //Jobs

  GetCubeProjects(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBJOBS_CUBE", "pageindex": page, "pagesize": size, "searchtext": filter })
  }

  GetAccountingSystemJobs(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBJOBS_QB", "pageindex": page, "pagesize": size, "searchtext": filter })
  }

  GetSynchronizedProjects(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBJOBS", "pageindex": page, "pagesize": size, "searchtext": filter });
  }

  //Vendors

  GetCubeVendors(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBVENDOR_CUBE", "pageindex": page, "pagesize": size, "searchtext": filter });
  }

  GetAccountingSystemVendors(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBVENDOR_QB", "pageindex": page, "pagesize": size, "searchtext": filter });
  }

  GetSynchronizedVendors(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBVENDOR_SYNCH", "pageindex": page, "pagesize": size, "searchtext": filter });
  }

  //Employees

  GetCubeEmployees(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBEMPLOYEES_CUBE", "pageindex": page, "pagesize": size, "searchtext": filter });
  }

  GetAccountingSystemEmployees(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBEMPLOYEES_QB", "pageindex": page, "pagesize": size, "searchtext": filter });
  }

  GetSynchronizedEmployees(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBEMPLOYEES_SYNCH", "pageindex": page, "pagesize": size, "searchtext": filter });
  }

  //Payroll

  GetCubePayroll(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBPAYROLLTYPE_CUBE", "pageindex": page, "pagesize": size, "searchtext": filter });
  }

  GetAccountingSystemPayroll(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBPAYROLLTYPE_QB", "pageindex": page, "pagesize": size, "searchtext": filter });
  }

  GetSynchronizedPayroll(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBPAYROLLTYPE_SYNCH", "pageindex": page, "pagesize": size, "searchtext": filter });
  }

  //Sales Tax

  GetCubeSalesTax(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBTAX_CUBE", "pageindex": page, "pagesize": size, "searchtext": filter })
  }

  GetQBSalesTax(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBTAX_QB", "pageindex": page, "pagesize": size, "searchtext": filter })
  }

  GetSyncSalesTax(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBTAX_SYNCH", "pageindex": page, "pagesize": size, "searchtext": filter })
  }

  //Service Items

  GetCubeServices(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBSERVICE_CUBE", "pageindex": page, "pagesize": size, "searchtext": filter })
  }

  GetQBServices(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBSERVICE_QB", "pageindex": page, "pagesize": size, "searchtext": filter })
  }

  GetSyncServices(page, size, filter) {
    return this.http.post<any>(this.baseurl + this.apiroute, { "method": "Get_AcctQBSERVICE_SYNCH", "pageindex": page, "pagesize": size, "searchtext": filter })
  }

  //Transaction Log

  GetTransactionLog(date) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_Integration_TransactionLogAll', tsdate: date })
  }

  //Sincronizaciones

  Sync_Customer(reference, id: number) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Syn_Customer', 'acctrefference': reference, 'customerid': id })
  }

  Sync_CustomerNV(id: number) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Syn_Customer', 'customerid': id })
  }

  Sync_JobNV(id: number) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Syn_Jobs', 'projectid': id })
  }

  Sync_VendorNV(id: number) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Syn_Vendors', 'vendorid': id })
  }

  Sync_ServiceNV(id: number) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Syn_Services', 'serviceid': id })
  }

  Sync_PayrollNV(id: number) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Syn_Payrolls', 'payrollid': id })
  }

  Sync_SalesNV(id: number) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Syn_Sales', 'saleid': id })
  }

  Sync_EmployeeNV(id: number) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Syn_Employees', 'employeeid': id })
  }

  Sync_Employees(reference, id) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Syn_Employees', 'acctqbname': reference, 'employeeid': id })
  }

  Sync_Jobs(reference, id) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Syn_Jobs', 'qbprojectname': reference, 'projectid': id })
  }

  Sync_Vendors(reference, id) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Syn_Vendors', 'acctrefference': reference, 'vendorid': id })
  }

  Sync_Payroll(reference, id) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Syn_Payroll', 'acctrefference': reference, 'payrollid': id })
  }

  Sync_Services(reference, id) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Syn_ServiceItems', 'acctrefference': reference, 'projecttodoid': id })
  }

  Sync_Sales(reference, id) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Syn_SalesTax', 'accreff': reference, 'clienttaxid': id })
  }

  //Datos Sincronizados

  SyncronizedCustomers() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_CustomerSynch' })
  }

  SyncronizedVendors() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_VendorSynch' })
  }

  SyncronizedPayroll() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_PayrollSynch' })
  }

  SyncronizedEmployees() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EmployeesSynch' })
  }

  UpdateComponentModule(obj: any) {
    return this.http.post<any>(this.baseurl + this.apiroute, obj)
  }  

  SyncronizedSales() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EmployeesSynch' })
  }

  SyncronizedJobs() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EmployeesSynch' })
  }

  //Settings

  ClientSettings() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_ClientSettingsByName', 'name': 'QBCompany' })
  }

  UpdateClientSettings(description, value) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Update_ClientSettings', 'name': 'QBCompany', 'description': description, 'value': value })
  }

  synchEntities(usr: string) {
    return this.http.get<any>(this.quickbooksurl + 'QBO/CreateCustomer?tk=' + localStorage.getItem('token') + '&usr=' + usr, {});
  }

  synchCustomerCEToQB(usr: string) {
    return this.http.get<any>(this.quickbooksurl + 'QBO/InsertCustomer?tk=' + localStorage.getItem('token') + '&usr=' + usr, {});
  } 

  Delete_QBtrx(data) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Delete_QBtrx', 'id': data })
  }
  SP_API_Flex_Delete_QB(ids) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Delete_QBCustomer', 'id': ids })
  }
  SP_API_Flex_Delete_QBAllCustomer(preserve) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Delete_QBCustomerAll', preserve: preserve })
  }
  SP_API_Flex_Delete_QBAllProject(preserve) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Delete_QBJobAll', preserve: preserve })
  }
  SP_API_Flex_Delete_QBAllVendor(preserve) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Delete_QBVendorAll', preserve: preserve })
  }
  SP_API_Flex_Delete_QBAllEmployees(preserve) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Delete_QBEmployeeAll', preserve: preserve })
  }
  SP_API_Flex_Delete_QBAllPayrolls(preserve) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Delete_QBPayrollAll', preserve: preserve })
  }
  SP_API_Flex_Delete_QBServiceAll(preserve) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Delete_QBServiceAll', preserve: preserve })
  }
  SP_API_Flex_Delete_QBSalesAll(preserve) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Delete_QBSalesAll', preserve: preserve })
  }
  SP_API_Flex_Delete_QBAllJobs() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Delete_QBJobsAll' })
  }
  UnlinkAllCustomers() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'UnSyn_AllCustomer' })
  }
  UnlinkAllJobs() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'UnSyn_AllJobs' })
  }
  UnlinkAllVendors() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'UnSyn_AllVendors' })
  }
  UnlinkAllEmployees() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'UnSyn_AllEmployees' })
  }
  UnlinkAllpayrolls() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'UnSyn_AllPAyrolls' })
  }
  UnlinkAllservices() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'UnSyn_AllServices' })
  }
  UnlinkAllsales() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'UnSyn_AllSales' })
  }
  Get_ProjectsQB() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_ProjectsQB' })
  }
  Get_CustomerQB() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_CustomerQB' })
  }
  Get_JobsQB() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_JobsQB' })
  }
  Get_VendorsQB() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_VendorsQB' })
  }
  Get_EmployeesQB() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EmployeesQB' })
  }
  Get_PayrollsQB() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_PayrollsQB' })
  }
  Get_ServicesQB() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_ServicesQB' })
  }
  Get_SalesQB() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_SalesQB' })
  }
  SP_API_Flex_Delete_QBProject(ids) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Delete_QBProject', 'id': ids })
  }
  SP_API_Flex_Delete_QBVendor(ids) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Delete_QBVendor', 'id': ids })
  }
  SP_API_Flex_Delete_QBEmployee(ids) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Delete_QBEmployee', 'id': ids })
  }
  SP_API_Flex_Delete_QBServiceitems(ids) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Delete_QBServiceitems', 'id': ids })
  }
  SP_API_Flex_Delete_QBTaxcode(ids) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Delete_QBTaxcode', 'id': ids })
  }
  SP_API_Flex_Delete_QBPayrollitems(ids) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Delete_QBPayrollitems', 'id': ids })
  }
  SP_API_Flex_Insert_CustomerfromQB(ids) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Insert_CustomerfromQB', 'id': ids })
  }
  BreakLink(id: string) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'breakCustomerQBLink', 'id': id })
  }
  BreakLinkProject(id: string) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'breakProjectQBLink', 'id': id })
  }
  BreakLinkVendor(id: string) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'breakVendorQBLink', 'id': id })
  }
  BreakLinkPayroll(id: string) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'breakPayrollQBLink', 'id': id })
  }
  BreakLinkService(id: string) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'breakServiceQBLink', 'id': id })
  }
  BreakLinkSale(id: string) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'breakSaleQBLink', 'id': id })
  }
  SP_API_Flex_Insert_JobfromQB(ids) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Insert_ProjectfromQB', 'id': ids })
  }
  SP_API_Flex_Insert_VendorfromQB(ids) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Insert_VendorfromQB', 'id': ids })
  }
  SP_API_Flex_Insert_EmployeefromQB(ids) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Insert_EmployeefromQB', 'id': ids })
  }
  SP_API_Flex_Insert_PayrollfromQB(ids) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Insert_PayrollfromQB', 'id': ids })
  }
  SP_API_Flex_InsertServicefromQB(ids) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Insert_ServicefromQB', 'id': ids })
  }
  SP_API_Flex_InsertSalesfromQB(ids) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Insert_SalesfromQB', 'id': ids })
  }

}
